<template>
  <button><slot></slot></button>
</template>


<style scoped>
button {
  background-color: #B9AA89;
  border: outset 3px #DDD5C5;
  border-radius: 1em;
  box-shadow: 5px 5px 9px 2px rgba(79, 74, 75, 0.3);
}
@media (hover: hover) {
  button:hover {
    background-color: #AC996E;
    border: inset 3px #DDD5C5;
    border-radius: 1em;
    box-shadow: 1px 1px 5px 1px rgba(79, 74, 75, 0.3);
  }
}
button:active {
  background-color: #AC996E;
  border: inset 3px #DDD5C5;
  border-radius: 1em;
  box-shadow: 1px 1px 5px 1px rgba(79, 74, 75, 0.3);
}
button:disabled {
  background-color: #927e52;
  border: inset 3px #DDD5C5;
  cursor: not-allowed;
  box-shadow: 1px 1px 5px 1px rgba(79, 74, 75, 0.2);
}
</style>